

import router from './router/router';
import store from './store';

//没有登录时可以直接访问的页面
const whiteList = ['/404', '/401', '/lock', '/login', '/register'];
const loginRG = /\/[a-zA-Z0-9]*\/login$/;

router.beforeEach((to, from, next) => {
  if(process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true'){
    next();
  }else{
    console.log("路由验权=======",loginRG.test(to.path),to.path);
    // 判断token是否有值，没有的话跳转到登录页
    if (store.getters.accessToken) {
      next();
    }else{
      if(whiteList.indexOf(to.path) !== -1||loginRG.test(to.path)){
        next();
      }else {
        next('/login')
      }
    }
  }

});


router.afterEach((to, from) => {
});

// // 解决Loading chunk 3 failed.的问题
// router.onError((error) => {
//   const pattern = /Loading chunk (\d)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   const targetPath = router.history.pending.fullPath;
//   if (isChunkLoadFailed) {
//     location.reload();
//   }
// });
